import { html } from 'lit';
const Crop =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M6.667 3.25a.75.75 0 0 1 .75.75v10.489c0 .51 0 .848.021 1.106.02.25.057.36.09.427.1.194.256.35.45.45.067.033.176.07.427.09.258.02.596.021 1.106.021h5.156a.75.75 0 0 1 0 1.5H9.48c-.472 0-.871 0-1.199-.026-.342-.028-.672-.09-.985-.25a2.53 2.53 0 0 1-1.105-1.104c-.16-.313-.22-.643-.249-.985a16 16 0 0 1-.026-1.2V7.418H4a.75.75 0 0 1 0-1.5h1.917V4a.75.75 0 0 1 .75-.75m8.929 4.188a15 15 0 0 0-1.107-.021H9.333a.75.75 0 0 1 0-1.5h5.186c.472 0 .871 0 1.199.026.342.028.672.09.985.25.476.242.863.628 1.105 1.104.16.313.22.643.249.985.026.328.026.727.026 1.2v7.101H20a.75.75 0 0 1 0 1.5h-1.917V20a.75.75 0 0 1-1.5 0V9.511c0-.51 0-.848-.021-1.106-.02-.25-.057-.36-.09-.427a1.03 1.03 0 0 0-.45-.45c-.067-.033-.176-.07-.426-.09" clip-rule="evenodd"/>
  </svg>
`;
export default Crop;
